module.exports = __webpack_public_path__ + "static/media/right_arrow_table.b104e7fd.svg";